import {
	getCoreRowModel,
	TableOptions,
	useReactTable,
	createColumnHelper as createColumnHelperReactTable,
	flexRender as flexRenderReactTable,
	type SortingState as SortingStateType
} from '@tanstack/react-table';

type UseTableProps<T> = Omit<TableOptions<T>, 'getCoreRowModel'>;

export const useTable = <TData,>({ ...props }: UseTableProps<TData>) => {
	const table = useReactTable<TData>({
		manualSorting: true,
		enableMultiSort: false,
		...props,
		getCoreRowModel: getCoreRowModel()
	});

	const headers = table.getHeaderGroups();
	const { rows } = table.getRowModel();

	return {
		headers,
		rows
	};
};

export const createColumnHelper = createColumnHelperReactTable;
export const flexRender = flexRenderReactTable;
export type SortingState = SortingStateType;
